import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable, startWith, map, combineLatest, forkJoin } from 'rxjs';
import { Country } from 'src/app/core/models/country.model';
import { kraPintype } from 'src/app/core/models/kRAPintype.model';
import { MyPolicy } from 'src/app/core/models/my-policy.model';
import { PaymentMethod } from 'src/app/core/models/payment-method.model';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { Quote } from 'src/app/core/models/quote.model';
import { Relationship } from 'src/app/core/models/relationship.model';
import { TravelPurpose } from 'src/app/core/models/travel-purpose.model';
import { Traveller } from 'src/app/core/models/traveller.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-policy-info',
  templateUrl: './policy-info.component.html',
  styleUrls: ['./policy-info.component.scss']
})
export class PolicyInfoComponent {
  policyInfo!: MyPolicy;
  filteredDestinations: Observable<Country[]> | undefined;
  selectedDestinations: Country[] = [];
  @ViewChild('destinationInput') destinationInput!: ElementRef<HTMLInputElement>;
  @ViewChild('destinationInput1') destinationInput1!: ElementRef<HTMLInputElement>;
  minTripEndDate: any;
  submitted: boolean = false;
  minTripStartDate: any = new Date();
   currentLanguage: string = '';
  underwritingInfo: any = {
    "createdBy": "Arun Shiva",
    "travelDates": "12/05/2024 - 20/05/2024",
    "destination": "United Arab Emirates(UAE), Oman, Kuwait..",
    "underwritingDetails": [
      {
        "id": "1",
        "title": "Quote Information"
      },
      {
        "id": "2",
        "title": "Proposal Form"
      },
      {
        "id": "3",
        "title": "Travelers"
      },
      {
        "id": "4",
        "title": "Coverages"
      },
      // {
      //   "id":"5",
      //   "title":"Policy Confirmation"
      // },
      // {
      //   "id":"6",
      //   "title":"Payment Methods"
      // }
    ]
  }
  paymentMethods: PaymentMethod[] = [];
  currentActiveIndex: number = 0;
  quotationFieldsForm = this.fb.group({
    travelPurpose: [{ value: '', disabled: true }],
    destination: [{ value: '', disabled: true }],
    tripStartDate: [{ value: '', disabled: true }],
    tripEndDate: [{ value: '', disabled: true }],
    travelingDays: [{ value: '', disabled: true }],
    numberOfTravelers: [{ value: '', disabled: true }],
  });

  proposalForm = this.fb.group({
    productName: [{ value: '', disabled: true }],
    premiumAmount: [{ value: '', disabled: true }],
    destination: [{ value: '', disabled: true }],
    tripStartDate: [{ value: '', disabled: true }],
    tripEndDate: [{ value: '', disabled: true }],
    travelingDays: [{ value: '', disabled: true }],
    numberOfTravelers: [{ value: '', disabled: true }],
    kraPinType:[{ value: '', disabled: true }],
    kraPinNumber: [{ value: '', disabled: true }],
    beneficiaryName:[{ value: '', disabled: true }],
    beneficiaryTelephoneNo: [{ value: '', disabled: true }],
    insuredOccupation: [{ value: '', disabled: true }],
    address: this.fb.group({
      houseNumber: [{ value: '', disabled: true }],
      roadName: [{ value: '', disabled: true }],
      pincode: [{ value: '', disabled: true }]
    }),
  });


  travelersForm = this.fb.group({
    travelersDetails: this.fb.array([])
  });

  quotationId: string = '';
  quotesId: string = '';
  countryCodes: any[] = [];
  getTravelPurposeList: TravelPurpose[] = [];
  getCountriesList: Country[] = [];
  relationshipList: Relationship[] = [];
  selectedProduct!: Quote;
  quotationInfo!: QuotationInfo;
  travellerList: Traveller[] = [];
  coverages: any[] = [];
  dateOfBirthMaxDate = moment().subtract(1, 'years');
  messages = [
    "We're crafting your policy. Thanks for waiting!",
    "Your policy is on its way. Hang in there!",
    "Just a moment longer for your custom policy.",
    "We're working on your policy. Almost done!",
    "Thanks for your patience while we generate your policy.",
    "Sit tight! Your policy is being tailored.",
    "Your policy is in progress. Appreciate your patience!",
    "Just a few more seconds for your personalized policy.",
    "Your policy is getting ready. Thanks for waiting!",
    "We're on it! Your policy will be ready soon."
  ];
  currentMessage!: string;
  buyPolicyFormSubmitted: boolean = false;
  kRAPintypeList:kraPintype[]=[];
  productDetails: any[] = [];
  coveragesList: any[] = [];
  constructor(
    private fb: FormBuilder,
    private restService: RestService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
     private translate: TranslateService
  ) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
      this.quotesId = params['quotesId'];
    });

    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
     this.currentLanguage = this.translate.currentLang;
     this.translate.onLangChange.subscribe((event: any) => {
      this.currentLanguage = event.lang;
     })
  }

  ngOnInit() {
    this.PolicyInfoPageLoadApis();
    this.QuotationCompare();
  }

  QuotationCompare() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/QuotationB2CCompare').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.coveragesList = data.rObj.Coverages;
              this.productDetails = data.rObj.QuotationCompare.filter((item: any)=>item.QuotesID==this.quotesId).map((item: any) => ({
                ProductID: item.ProductID,
                ProductName: item.ProductName,
                coverageQuotesCompare: item.coverageQuotesCompare.reduce((acc: any, coverage: any) => {
                  acc[coverage.CoverageID] = coverage.additionalData.reduce((adAcc: any, ad: any) => {
                    adAcc[ad.AdditionalCoverageID] = ad.AdditionalCoverageDescriptionUserLimit;
                    return adAcc;
                  }, {});
                  return acc;
                }, {})
              }));



            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  PolicyInfoPageLoadApis() {
    let userInfoParams = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }

    let myPolicyInfoParams = {
      QuotationID: this.quotationId
    }
    const getMasterDataApiCall$ = this.restService.postData({
    "id": this.currentLanguage == 'en' ? '1' : '2', // Assuming 1 is for English and 2 for other languages
}, 'api/Quotation/GetMasterData');
    const userInfoApiCall$ = this.restService.postData(userInfoParams, 'api/Quotation/UserInfo');
    const myPolicyInfoApiCall$ = this.restService.postData(myPolicyInfoParams, 'api/Quotation/MyPolicyInfo');

    forkJoin([getMasterDataApiCall$, userInfoApiCall$, myPolicyInfoApiCall$]).subscribe({
      next: ([masterData, userInfoData, policyInfo]) => {
        try {
          if (masterData.rcode == 200 && userInfoData.rcode == 200 && policyInfo.rcode == 200) {
            this.getTravelPurposeList = masterData.rObj.GetTravelPurpose || [];
            this.getCountriesList = masterData.rObj.GetCountries || [];
            this.relationshipList = masterData.rObj.Relationship || [];
            this.paymentMethods = masterData.rObj.PaymentMethods || [];
            this.countryCodes = masterData.rObj.CountryCode || [];
            this.kRAPintypeList = masterData.rObj.kRAPintype || [];

            this.quotationInfo = userInfoData.rObj.Quotations;
            this.selectedProduct = userInfoData.rObj.Quotes;
            this.travellerList = userInfoData.rObj.Traveller || [];
            this.coverages = userInfoData.rObj.Coverages || [];
            let selectedDestinationsList = userInfoData.rObj.DestinationCountry || [];
            let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
            this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
            this.SetValuesToForms();
            this.numberOfTravelers();

            this.policyInfo = policyInfo.rObj.MyPolicyInfo || {};
          } else if (masterData.rcode != 200) {
            this.errorHandler.handleRcodeError(masterData);
          } else if (userInfoData.rcode != 200) {
            this.errorHandler.handleRcodeError(userInfoData);
          } else if (policyInfo.rcode != 200) {
            this.errorHandler.handleRcodeError(policyInfo);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      error: error => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      }
    });
  }

  dateOfBirthChange(event: MatDatepickerInputEvent<Date>, index: number) {
    let dob = this.getTravelersDetails.at(index).get('dateOfBirth')?.value;
    let getAge = this.calculateAge(dob);
    this.getTravelersDetails.at(index).get('age')?.patchValue(getAge);
  }

  GetMasterData() {
    this.loader.show();
    this.restService.postData({
    "id": this.currentLanguage == 'en' ? '1' : '2', // Assuming 1 is for English and 2 for other languages
}, 'api/Quotation/GetMasterData').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.getTravelPurposeList = data.rObj.GetTravelPurpose || [];
              this.getCountriesList = data.rObj.GetCountries || [];
              this.relationshipList = data.rObj.Relationship || [];
              this.paymentMethods = data.rObj.PaymentMethods || [];
              this.countryCodes = data.rObj.CountryCode || [];
              
              this.GetQuotesUserInfo();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  GetQuotesUserInfo() {
    let params = {
      QuotationID: this.quotationId,
      QuotesID: this.quotesId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/UserInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotationInfo = data.rObj.Quotations;
              this.selectedProduct = data.rObj.Quotes;
              this.travellerList = data.rObj.Traveller || [];
              this.coverages = data.rObj.Coverages || [];
              let selectedDestinationsList = data.rObj.DestinationCountry || [];
              let selectedDestinationsIds = selectedDestinationsList.map((sdl: any) => sdl.DestinationCountryID);
              this.selectedDestinations = this.getCountriesList.filter(country => selectedDestinationsIds.includes(country.TocountryID));
              this.SetValuesToForms();
              this.numberOfTravelers();
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  SetValuesToForms() {

    this.quotationFieldsForm.patchValue({
      destination: '',
      travelPurpose: this.quotationInfo.TravelPurposeID,
      tripStartDate: this.quotationInfo.FromDate,
      tripEndDate: this.quotationInfo.ToDate,
      travelingDays: this.quotationInfo.NoofDays?.toString(),
      numberOfTravelers: this.quotationInfo.NoofTravellers?.toString()
    });


    this.proposalForm.patchValue({
      productName: this.selectedProduct.ProductName,
      premiumAmount: this.selectedProduct.sTotalAmount,
      destination: '',
      tripStartDate: this.quotationInfo.FromDate,
      tripEndDate: this.quotationInfo.ToDate,
      travelingDays: this.quotationInfo.NoofDays?.toString(),
      numberOfTravelers: this.quotationInfo.NoofTravellers?.toString(),
      kraPinType: this.quotationInfo.KRAPinTypeID,
      kraPinNumber: this.quotationInfo.KRAPinNumber,
      insuredOccupation: this.quotationInfo.Occupation,
      beneficiaryName: this.quotationInfo.BeneficiaryName,
      beneficiaryTelephoneNo: this.quotationInfo.BeneficiaryPhoneNumber,
      address: {
        houseNumber: this.quotationInfo.AddressLine1,
        roadName: this.quotationInfo.AddressLine2,
        pincode: this.quotationInfo.AddressLine3
      },
    });
  }

  changeActiveIndex(index: number) {
    this.currentActiveIndex = index;
  }

  numberOfTravelers(): void {
    this.getTravelersDetails.clear();
    for (const traveller of this.travellerList) {
      this.getTravelersDetails.push(this.newTravelersDetaile(traveller));
    }
  }

  newTravelersDetaile(traveller: Traveller): FormGroup {
    return this.fb.group({
      isProposerATraveller: [{ value: traveller.IsPolicyHolder, disabled: true }],
      firstName: [{ value: traveller.FirstName, disabled: true }],
      lastName: [{ value: traveller.LastName, disabled: true }],
      nameAsPerThePassport: [{ value: traveller.Fullname, disabled: true }],
      dateOfBirth: [{ value: traveller.DOB, disabled: true }],
      age: [{ value: traveller.Age, disabled: true }],
      // mobileCode: [{ value: traveller.PhoneNumberCountryCode, disabled: true }],
      mobileCode: [{ value: '5bde1eaa-2cd1-4a46-ad1f-a1b21020bdae', disabled: true }],
      mobileNumber: [{ value: traveller.PhoneNumber, disabled: true }],
      emailId: [{ value: traveller.EmailId, disabled: true }],
      passportNumber: [{ value: traveller.PolicyHolderPassPortNumber, disabled: true }],
      relationshipWithTheProposer: [{ value: traveller.RelationshipTypeID, disabled: true }],
      passportFile: [{ value: '', disabled: true }],
      passportFileAttachmentID: [{ value: traveller.PassportAttachmentID, disabled: true }],
    })
  }

  get getTravelersDetails(): FormArray {
    return this.travelersForm.get("travelersDetails") as FormArray;
  }

  remove(destination: Country): void {
    const index = this.selectedDestinations.indexOf(destination);
    if (index >= 0) {
      this.selectedDestinations.splice(index, 1);
      // this.onFocus();
    }
  }

  DownloadPassportCopy(index: number) {
    let attachmentID = this.getTravelersDetails.at(index).get('passportFileAttachmentID')?.value
    let params = {
      AttachmentID: attachmentID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/DownloadUserProfile').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.URL) {
                window.open(data.rObj.URL, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCountry = this.getCountriesList.find(country => country.TocountryID === event.option.value);
    if (selectedCountry) {
      this.selectedDestinations.push(selectedCountry);
      this.destinationInput.nativeElement.value = '';
      this.proposalForm.get('destination')?.patchValue('');
      // this.onFocus();
    }
  }

  onFocus() {
    this.filteredDestinations = this.proposalForm.get("destination")?.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    ) as Observable<Country[]>;
  }

  private _filter(value: string): Country[] {
    const filterValue = value.toLowerCase();
    return this.getCountriesList.filter(country =>
      country.ToCountryName.toLowerCase().includes(filterValue) &&
      !this.selectedDestinations.some(selected => selected.TocountryID === country.TocountryID)
    );
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  calculateAge(dob: Date): number {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  TryAgain() {
    window.location.reload();
  }

  goBack() {
    history.back();
  }

  DownloadPolicy(certificateID: string) {
    let params = {
      certificateID: certificateID
    }
    this.loader.show();
    this.restService.postData(params, 'api/Integration/PrintCertificate').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              if (data.rObj.PrintCertificate.printCertificateResponse.printCertificateResult) {
                window.open(data.rObj.PrintCertificate.printCertificateResponse.printCertificateResult, '_target');
              }
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
}

